import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {seatingType_add_action,seatingType_detail_action
} from "../../../actions/master_actions/seatingType_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import { centerActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";

class serviceTypeAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      userId: "",
      SittingTypeID: "",
      StatusID: "",
      SittingTypeName: "",
      StatusID: "",
      sittingTypeData: [],
      CenterList:[]
    };
    this.navigateBackEvent = this.navigateBackEvent.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sittingTypeDetails = this.sittingTypeDetails.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }
  componentDidMount() {
    console.log(this.props.location);
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId, Status } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      StatusID: this.props.location.state?.StatusID
        ? this.props.location.state?.StatusID
        : "",
    });
    console.log(this.props.location.state);
    const SittingTypeID = this.props.location.state?.SittingTypeID || "";
    if (SittingTypeID) {
      this.setState({ SittingTypeID }, () => {
        this.sittingTypeDetails();
      });
    } else {
      this.setState({
        Code: this.props.location.state?.Code
          ? this.props.location.state?.Code
          : "",
      });
      this.clearFields();
    }
    this.getFillList(centerActionId, userId, "", "");

  }

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == centerActionId) {
            this.setState({ CenterList: data.data, isLoading: false });
          }
          
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  clearFields() {
    this.setState({
      SittingTypeID: "",
      SittingTypeName: "",
      StatusID: 0,
    });
  }

  navigateBackEvent() {
    this.props.navigate("/seatingType");
  }
  sittingTypeDetails() {
    const { userId, SittingTypeID } = this.state;
    if (SittingTypeID) {
      this.props
        .seatingType_detail_action(SittingTypeID)
        .then((data) => {
          console.log("event details--------", data);
          if (data.error !== 1) {
            this.setState({
              SittingTypeName: data.data[0]["SittingTypeName"],
              StatusID: data.data[0]["StatusID"],
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.data, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  handleInputChange(event) {
    const { SittingTypeName, value } = event.target;
    this.setState({
      [SittingTypeName]: value,
    });
  }
  handleSubmit() {
    var { userId, SittingTypeID, SittingTypeName, StatusID } = this.state;
    console.log("testing------->", userId, SittingTypeID, SittingTypeName, StatusID);
    if (SittingTypeName == "") {
      this.setState({ isLoading: false });
      toast.error("Sitting Type Name cannot be blank", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      this.setState({ isLoading: true });
      
      const finalStatus = StatusID ? 1 : 0; // Convert checkbox value to 1 or 0
      // Update operation
      this.props
        .seatingType_add_action( SittingTypeID, SittingTypeName, finalStatus)
        .then((data) => {
          console.log(data, "update");
          if (data.error !== 1) {
            this.setState({ isLoading: false },()=>{
              toast.success(
                SittingTypeID?'Updated Successfully':'Submitted Successfully',
                {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                }
              );
              setTimeout(() => {
                this.props.navigate("/seatingType");
              }, 1000); // Adjust the delay time as needed
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  render() {
    const { SittingTypeID, SittingTypeName, CenterID, StatusID, isLoading,CenterList } = this.state;
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />
            <div className="container-fluid">
              <section style={{ marginTop: 115 }}>
              <div className="page-header">
                  <h4 className="page-title">
                    {SittingTypeID ? "Edit" : "Add"} Seating Type
                  </h4>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {SittingTypeID
                        ? StatusID == 1
                          ? "Active"
                          : "Inactive"
                        : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {SittingTypeID ? (
                          <>
                            <input
                              type="checkbox"
                              checked={StatusID}
                              onChange={() => {
                                this.setState((prevState) => ({
                                  StatusID: !prevState.StatusID,
                                }));
                              }}
                            />
                            <span class="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={1} />
                            <span class="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </section>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-3 mb-3">
                      <label htmlFor="inputZip">
                      Seating Type Name <span className="mendatory_class">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={50}
                        id="fname"
                        name="name"
                        value={this.state.SittingTypeName}
                        onChange={(e) =>
                          this.setState({ SittingTypeName: e.target.value })
                        }
                      />
                    </div>
                    
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <a
                        href="javascript:void(0);"
                        onClick={this.handleSubmit}
                        className="btn save_btn mr-2"
                      >
                        {SittingTypeID?"Update":"Save"}
                      </a>
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.navigateBackEvent()}
                        className="btn back_btn"
                        id="cancel_co_applicant_pop"
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, { seatingType_add_action,seatingType_detail_action,fill_action})(serviceTypeAU)
);
